import ServiceCard from "../components/ServiceCard";
import "../components/Services.css";

const Services = () => {
  return (
    <section className="services-section py-5" style={{
    backgroundImage: "url(/graphics/images/ourservicesbg.png)",
  }}>
      <div className="container">

        {/* Section Title */}
        <div className="row mb-5">
          <div className="col text-center">
            <h2 className="services-title">Our Services</h2>
          </div>
        </div>

        {/* Services Grid */}
        <div className="row g-4 justify-content-center">

          <div className="col-lg-4 col-md-6 text-justify">
            <ServiceCard
              icon={
      <img
        src="/graphics/images/webdevelopmenticon.svg" width="92" height="92"
        alt="Web Development"
        className="service-icon"
      />
    }
              title="Web Development Services"
              description="At CodeInputs, we build powerful, scalable, and visually engaging websites that help businesses grow online. Our focus is on performance, usability, and modern technology—so your website not only looks great but works flawlessly."
            />
          </div>

          <div className="col-lg-4 col-md-6">
            <ServiceCard
              icon={
      <img
        src="/graphics/images/softwaredevelopmenticon.svg" width="92" height="92"
        alt="Software Development Services"
        className="service-icon"
      />
    }
              title={<>Software Development Services</>}
              description="At CodeInputs, we design and develop reliable, high-quality software solutions that solve real business problems. From concept to deployment, we focus on performance, security, and scalability."
            />
          </div>

          <div className="col-lg-4 col-md-6">
            <ServiceCard
              icon={
      <img
        src="/graphics/images/applicationdevelopmenticon.svg" width="92" height="92"
        alt="Application Development Services"
        className="service-icon"
      />
    }
              title="Application Development Services"
              description="At CodeInputs, we build smart, secure, and high-performance applications that deliver seamless user experiences. From idea to launch, our applications are designed to scale with your business and adapt to future needs."
            />
          </div>

          <div className="col-lg-4 col-md-6">
            <ServiceCard
              icon={
      <img
        src="/graphics/images/Artboard 1.svg" width="92" height="92"
        alt="Custom API Creation And Integration"
        className="service-icon"
      />
    }
              title="Custom API Creation And Integration"
              description="At CodeInputs, we design and integrate secure, scalable, and high-performance APIs that connect your applications, systems, and services seamlessly. Our APIs ensure smooth data flow and reliable communication across platforms."
            />
          </div>

          <div className="col-lg-4 col-md-6">
            <ServiceCard
              icon={
      <img
        src="/graphics/images/socialmediaicon.svg" width="92" height="92"
        alt="Social Media Handling Services"
        className="service-icon"
      />
    }
              title="Social Media Handling Services"
              description="At CodeInputs, we help brands build a strong and consistent social media presence that drives engagement, builds trust, and grows your audience. From content creation to performance tracking, we manage your social platforms end-to-end."
            />
          </div>

          <div className="col-lg-4 col-md-6">
            <ServiceCard
              icon={
      <img
        src="/graphics/images/graphicsdesigningicon.svg" width="92" height="92"
        alt="Graphics Designing Services"
        className="service-icon"
      />
    }
              title="Graphics Designing Services"
              description="At CodeInputs, we create visually compelling designs that communicate your brand message clearly and creatively. Our designs are crafted to attract attention, build trust, and leave a lasting impression across all digital and print platforms."
            />
          </div>

          <div className="col-lg-4 col-md-6">
            <ServiceCard
              icon={
      <img
        src="/graphics/images/logodesigningicon.svg" width="92" height="92"
        alt="Logo Designing Services"
        className="service-icon"
      />
    }
              title="Logo Designing Services"
              description="At CodeInputs, we design unique, memorable, and meaningful logos that represent your brand’s identity and values. Our logos are crafted to make a strong first impression and create long-lasting brand recognition."
            />
          </div>

          <div className="col-lg-4 col-md-6">
            <ServiceCard
              icon={
      <img
        src="/graphics/images/digitalmarketingicon-01.svg" width="110" height="110"
        alt="Digital Marketing Services"
        className="service-icon"
      />
    }
              title="Digital Marketing Services"
              description="At CodeInputs, we create result-driven digital marketing strategies that help your business reach the right audience, build a strong online presence, and generate more leads. Our marketing solutions are designed to increase brand visibility, engage your customers, and support long-term business growth."
            />
          </div>

        </div>
      </div>
    </section>
  );
};

export default Services;
